import { Component } from '@angular/core';
import { LookupGetService } from '../../service/lookup-service/lookup-get.service';
import { FieldType } from '@ngx-formly/core';
import { LoggerService } from '../../service/logger-service/logger.service';

@Component({
  selector: 'app-condition-query-select-type-with-default-value',
  templateUrl: './condition-query-select-type-with-default-value.component.html',
  styleUrl: './condition-query-select-type-with-default-value.component.scss'
})
export class ConditionQuerySelectTypeWithDefaultValueComponent extends FieldType{
  isChecked: boolean = false;
  results: any = [];
  style: any = {'height': '37.6px'};
  constructor(
    public lookupService: LookupGetService,
    private loggerService: LoggerService) {
    super();
  }

  ngOnInit() {
     // Verifica si ya hay un valor, si no, establece el valor por defecto
    if (this.formControl.value === null || this.formControl.value === undefined) {
      this.formControl.setValue(this.props['defaultValue']); // Asignar valor por defecto si no hay valor
    }
    this.loadLookup(); // Carga las opciones independientemente del valor
    this.isChecked = this.formControl.value != null; // Asigna el estado de isChecked
  }

  manageCheck() {
    //Block the reset if permantCheck is active
    let permanentCheck = this.props['permanentCheck'];
    if (!permanentCheck) {
      if (this.isChecked) {
        this.isChecked = !this.isChecked;
        if (!this.isChecked) {
          this.results = [];
          this.formControl.setValue(null);
        }
      }
    }
  }

  loadLookup() {
    const lookup = this.field.props!['lookup'];
    this.lookupService.loadCachedOptions(lookup).subscribe(
      (data) => {
        this.results = data;
      },
      (error) => {
        this.loggerService.err('Error loading options', error);
      }
    );
  }

  onInputChange() {
    if (this.formControl.value) {
      this.isChecked = true;
      this.props['isModified'] = true;
      this.props['defaultValue'] = this.formControl.value;
    } else {
      this.isChecked = false;
      this.props['isModified'] = false;
      this.props['defaultValue'] = null;
    }
  }
}
